module.exports = __webpack_public_path__ + "HowItWorks_Header_new.2ff702d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/HowItWorks_Header_new.png
// module id = 1ovP
// module chunks = 0